export enum EtlJobLogStatusEnum {
  Running = "running",
  Failed = "failed",
  Success = "success",
}
